import { createContext, useEffect, useState } from "react";

export const ModalContext = createContext<[string, (x: string) => void, (x: string) => boolean]>([
    '',
    () => {},
    () => {return false;}
]);

// To use this provider you pass it a unique sting that it can use to determine the modal that is open
export const ModalProvider = ({ children }: any) => {
  const [open, setOpen] = useState<string>('');

  const isOpen = (identifier: string): boolean => {
    return open === identifier;
  }

  return (
    <ModalContext.Provider value={[open, setOpen, isOpen]}>
      {children}
    </ModalContext.Provider>
  );
};
